import { AdminTypes } from '../../../../components/Menu';
import AdminPanel from './adminPanel';
import BCBAPanel from './bcbaPanel';

import { useSelector } from '../../../../redux/store';

const InsuranceAuthorization = () => {
	const role = useSelector((state) => state.account.role);

	const showAdminLayout = role?.section.id === AdminTypes.admin || role?.section.id === AdminTypes.cs;
	const showBCBALayout = role?.section.id === AdminTypes.bcba;

	return (
		<>
			{showAdminLayout && <AdminPanel />}
			{showBCBALayout && <BCBAPanel />}
		</>
	);
};

export default InsuranceAuthorization;
